import * as React from 'react';
import { useRouter } from 'next/router';

const DATA_ATTRIBUTE = 'data-page';

export const GlobalClientRouter: React.FC = ({ children }) => {
  const { push } = useRouter();

  const overrideRoutedClick = React.useCallback(
    (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target && target.matches(`a[${DATA_ATTRIBUTE}], a[${DATA_ATTRIBUTE}] *`)) {
        let linkParent: HTMLElement = target;
        while (!linkParent.getAttribute(DATA_ATTRIBUTE) && linkParent.parentNode) {
          linkParent = linkParent.parentNode as HTMLElement;
        }
        const href = linkParent.getAttribute('href');
        const page = linkParent.getAttribute(DATA_ATTRIBUTE);
        if (!href || !page) {
          return;
        }
        event.preventDefault();
        push(href);
      }
    },
    [push],
  );
  React.useEffect(() => {
    window.addEventListener('click', overrideRoutedClick);
    return () => window.removeEventListener('click', overrideRoutedClick);
  }, [overrideRoutedClick]);

  return <>{children}</>;
};
